import { render, staticRenderFns } from "./AddTraineePO.vue?vue&type=template&id=8d2855b6&scoped=true"
import script from "./AddTraineePO.vue?vue&type=script&lang=js"
export * from "./AddTraineePO.vue?vue&type=script&lang=js"
import style0 from "./AddTraineePO.vue?vue&type=style&index=0&id=8d2855b6&prod&lang=css"
import style1 from "./AddTraineePO.vue?vue&type=style&index=1&id=8d2855b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2855b6",
  null
  
)

export default component.exports